import { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import CustomTextInput from './custom-text-input.atom';
import { FaChevronDown } from 'react-icons/fa';

const CustomSelect = ({
    label = '',
    error = '',
    helper = '',
    options = [],
    onChange = () => {},
    disabled = false,
    placeholder = 'Seleccionar',
    containerStyle,
    inputStyle,
    inputContainerStyle,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState({});
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleSelect = (option) => {
        onChange(option.value);
        setSelectedOption(option);
        setIsOpen(false);
    };

    return (
        <div ref={dropdownRef} style={{ position: 'relative', ...containerStyle }} onClick={() => !disabled && setIsOpen(!isOpen)}>
            <CustomTextInput
                label={label}
                value={selectedOption.label}
                error={error}
                helper={helper}
                disabled={disabled}
                placeholder={placeholder}
                inputContainerStyle={inputContainerStyle}
                inputStyle={inputStyle}
                right={() => (
                    <FaChevronDown 
                        style={{ 
                            color: isOpen ? '#FACE07' : '#626262',
                            transition: 'transform 0.2s ease',
                            transform: isOpen ? 'rotate(180deg)' : 'rotate(0)'
                        }} 
                    />
                )}
                readOnly
            />
            {isOpen && !disabled && (
                <div style={styles.dropdown}>
                    {options.map((option) => (
                        <div
                            key={option.id}
                            style={{
                                ...styles.option,
                                ...(selectedOption.id === option.id && styles.selectedOption)
                            }}
                            onClick={() => handleSelect(option)}
                        >
                            {option.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

const styles = {
    dropdown: {
        position: 'absolute',
        top: '100%',
        left: 0,
        right: 0,
        backgroundColor: '#FFFFFF',
        border: '1px solid #FACE07',
        borderRadius: '8px',
        marginTop: '4px',
        maxHeight: '200px',
        overflowY: 'auto',
        zIndex: 1000,
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    },
    option: {
        padding: '12px 16px',
        cursor: 'pointer',
        fontFamily: 'Inter, sans-serif',
        fontSize: '16px',
        lineHeight: '22px',
        color: '#000000',
        transition: 'background-color 0.2s ease',
        '&:hover': {
            backgroundColor: '#F5F5F5',
        },
    },
    selectedOption: {
        backgroundColor: '#F5F5F5',
        color: '#FACE07',
    },
};

CustomSelect.propTypes = {
    label: PropTypes.string,
    selectedId: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            value: PropTypes.any.isRequired,
        })
    ).isRequired,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    error: PropTypes.string,
    helper: PropTypes.string,
    placeholder: PropTypes.string,
    containerStyle: PropTypes.object,
    inputStyle: PropTypes.object,
    inputContainerStyle: PropTypes.object,
};

export default CustomSelect; 